module.exports = __webpack_public_path__ + "media/images/map_preview_portrait-4e5e1ef805c5b459288d8f74145c4e80.png";